module.exports = __webpack_public_path__ + "static/pid-ug-9-en-howtousesigncode-be24911d90d4d94ee3370c4e4d10c9e2.png";